let service = {};

if (typeof window !== 'undefined') {
    if (window.location.href.startsWith('http://localhost')) {
        service.API_URL = "http://localhost:8008";
    } else {
        service.API_URL = "https://api.pyther.com";
    }
}

export default service;